import React from "react";
import { node, oneOf, oneOfType, string } from "prop-types";

import calloutCardThemes from "../../constants/calloutCardThemes";
import imagePositions from "../../constants/imagePositions";
import * as S from "../styled";

const VerticalCalloutCardStatic = React.forwardRef(
  (
    {
      description,
      headline,
      illustration,
      imagePosition,
      legalCopy,
      theme,
      ...passThroughProps
    },
    ref
  ) => (
    <S.VerticalCardWrapper ref={ref} theme={theme} {...passThroughProps}>
      {illustration && (
        <S.StaticIllustrationWrapper
          imagePosition={imagePosition}
          legalCopy={legalCopy}
        >
          {illustration}
        </S.StaticIllustrationWrapper>
      )}
      <S.ContentWrapper>
        <S.Headline>{headline}</S.Headline>
        {description && <S.Description>{description}</S.Description>}
      </S.ContentWrapper>
      {legalCopy && (
        <>
          <S.Separator theme={theme} />
          <S.LegalCopy>{legalCopy}</S.LegalCopy>
        </>
      )}
    </S.VerticalCardWrapper>
  )
);

VerticalCalloutCardStatic.propTypes = {
  /**
   * Adds a description block to the Callout Card
   */
  description: string,

  /**
   * Headline for the Callout Card
   */
  headline: string.isRequired,

  /**
   * A component that defines the illustration for the Callout Card.
   */
  illustration: node,

  /**
   * If an illustration is provided, imagePosition will allow to align it to the bottom.
   */
  imagePosition: oneOf([imagePositions.TOP, imagePositions.BOTTOM]),

  /**
   * Adds a legal copy block to the Callout Card
   */
  legalCopy: oneOfType([node, string]),

  /**
   * The Callout Card theme. One of:
   *   - BLUE
   *   - ORANGE
   *   - GRAY
   *   - WHITE
   */
  theme: oneOf(Object.values(calloutCardThemes))
};

VerticalCalloutCardStatic.defaultProps = {
  description: null,
  legalCopy: null,
  illustration: null,
  imagePosition: imagePositions.TOP,
  theme: calloutCardThemes.WHITE
};

VerticalCalloutCardStatic.displayName = "VerticalCalloutCardStatic";

export default VerticalCalloutCardStatic;
